import React from 'react';
import { Button } from '@mui/material';

interface FinalizeArgumentButtonProps {
  handleFinalizeArgument: () => void;
  hasReceivedResponse: boolean;
  isFinalized: boolean;
  userInput: string;
}

const FinalizeArgumentButton: React.FC<FinalizeArgumentButtonProps> = ({
  handleFinalizeArgument,
  hasReceivedResponse,
  isFinalized,
  userInput,
}) => {
  // Hide if already finalized
  if (isFinalized) return null;

  return (
    <Button
      onClick={handleFinalizeArgument}
      disabled={!hasReceivedResponse || isFinalized || userInput.trim().length > 0}
      variant="contained"
      color="secondary" 
      // No size="small" => matches the default "medium" size
    >
      Finalize Argument
    </Button>
  );
};

export default FinalizeArgumentButton;
